<template>
  <div class="orderReview">
    <el-card class="box-card">
      <template slot="header">
        <div class="card-header">
          <span style="font-size:25px;font-weight:bold;margin:0 10px;">财务对账</span>
        </div>
      </template>
      <div style="display:flex;flex-flow:column">
        <div class="header-actions">
          <el-radio-group v-model="but_qs" style="margin-left:5px" @change="onQh">
            <el-radio-button label="最近1周"></el-radio-button>
            <el-radio-button label="最近2周"></el-radio-button>
            <el-radio-button label="最近30天"></el-radio-button>
          </el-radio-group>
          <el-date-picker
              v-model="edi_time"
              type="daterange"
              :clearable="false"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="margin-left:10px"
              @change="handleDateChange">
          </el-date-picker>
        </div>
        <div class="stats-overview">
          <div style="width:100%;margin-left:0%;">
            <el-row :gutter="10">
              <el-col :span="10">
                <div style="background-color:#e6f1fe;padding-top:10px">
                  <div style="display:flex;">
                    <el-row :gutter="10" style="width:100%">
                      <el-col :span="12">
                        <div class="son-item">
                          <div>总收入</div>
                          <div>{{ orderTotalMoney }}</div>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="son-item">
                          <div>订单数</div>
                          <div>{{ orderTotalNum }}</div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div style="background-color:#e6f1fe;padding-top:10px">
                  <div style="display:flex;">
                    <el-row :gutter="10" style="width:100%">
                      <el-col :span="8">
                        <div class="son-item">
                          <div>平均退款率</div>
                          <div>{{ orderRefundRate || 0 }}%</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="son-item">
                          <div>退款订单数</div>
                          <div>{{ orderRefundNum }}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="son-item">
                          <div>退款总额</div>
                          <div>{{ orderRefundMoney }}</div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-row :gutter="10" style="height: 25vh">
          <el-col :span="12" style="height:100%">
            <div style="width:100%;height:100%;background: #FFFFFF">
              <div style="height:10%;display: flex;align-items: center">
                <p style="margin-left:10px;font-weight:bold">每日收入统计</p>
              </div>
              <div style="width:100%;height:90%;display:flex;align-items:flex-end;">
                <div id="myMidC1" style="width:95%;height:95%;margin-left:3%;">
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" style="height:100%">
            <div style="width:100%;height:100%;background: #FFFFFF">
              <div style="height:10%;display: flex;align-items: center">
                <p style="margin-left:10px;margin-top:0;margin-bottom:10px;font-weight:bold">项目收入分布</p>
              </div>
              <div style="width:100%;height:90%;display:flex;align-items:flex-end;">
                <div id="myMidC2" style="width:95%;height:95%;margin-left:3%;">
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="height:30vh">
          <el-col :span="12" style="height:100%">
            <div style="width:100%;height:100%;background: #FFFFFF">
              <div style="height:10%;display: flex;align-items: center">
                <p style="margin-left:10px;font-weight:bold">退款率趋势</p>
              </div>
              <div style="width:100%;height:90%;display:flex;align-items:flex-end;">
                <div id="myMidC3" style="width:95%;height:95%;margin-left:3%;">
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" style="height:100%">
            <div style="width:100%;height:100%;background: #FFFFFF">
              <div style="height:10%;display:flex;align-items:center">
                <p style="margin-left:10px;font-weight:bold">退款原因分布</p>
              </div>
              <div style="width:100%;height:90%;display:flex;align-items:flex-end;">
                <div id="myMidC4" style="width:50%;height:95%;margin-left:3%;">
                </div>
                <div style="width:50%;height:100%;display:flex;flex-flow:column;">
                  <div v-for="(d,index) in li_mid4"
                       style="display:flex;align-items:center;width:50%;height:15%;color:#333;margin-top:10px">
                    <div
                        :style="{background:d['color'],width:'20px',height:'15px',marginLeft:'20px',borderRadius:'20px'}"></div>
                    <div style="margin-left:6px;width:160px;display:flex;justify-content: start">
                      {{ d['name'] }}
                    </div>
                    <div style="margin-left:1px;width:100px;display:flex;">{{ d['value'] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-table :data=orderList class="tab_orderCount" :cell-style="tableYs" border
                  style="width:100%;margin-top:10px;margin-left:1px;font-size:13px; background:#FFFFFF;"
                  show-overflow-tooltip
                  ref="multipleTable"
                  :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#f4f4f4', 'color': '#0dA7C8' }">
          <el-table-column prop="day" label="日期" width="180"></el-table-column>
          <el-table-column prop="roomName" label="会所空间" width="180"></el-table-column>
          <el-table-column prop="totalMoney" label="收入(元)"></el-table-column>
          <el-table-column prop="refundMoney" label="退款(元)"></el-table-column>
          <el-table-column prop="netIncome" label="净收入(元)"></el-table-column>
          <el-table-column prop="orderNum" label="订单数"></el-table-column>
          <el-table-column prop="refundNum" label="退款订单数"></el-table-column>
          <!--          <el-table-column label="操作" width="150">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button size="small" @click="viewOrderDetail(scope.row)">-->
          <!--                查看-->
          <!--              </el-button>-->
          <!--              <el-button size="small" type="primary" @click="editOrder(scope.row)">-->
          <!--                编辑-->
          <!--              </el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>

        <div style="width:100%;display: flex;align-items: center">
          <el-pagination
              style="margin-left: auto;margin-right:1px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import vueCropper from "../views/vueCropper.vue";
import moment from 'moment';

export default {
  name:'orderReview',
  components:{
    vueCropper
  },
  data() {
    return {
      h_text:"预约单财务统计",
      but_qs:"最近1周",
      totalOrders:0,
      orderList:[],
      page:1,
      pageSize:10,
      total:0,
      orderTotalNum:0,
      orderTotalMoney:0,
      orderRefundNum:0,
      orderRefundMoney:0,
      orderRefundRate:0,
      liMid1:[],
      li_mid1:[],
      li_mid1X:[],
      li_mid1Name:[],
      liMid2:[],
      li_mid2:[],
      li_mid2X:[],
      li_mid2Name:[],
      liMid3:[],
      li_mid3:[],
      li_mid3X:[],
      li_mid3Name:[],
      liMid4:[],
      li_mid4:[],
      dd1:require('@/assets/order/dd1.png'),
      edi_time:[
        moment().startOf('isoWeek').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      liSku:[],
      goodsId:0,
      li_color:[
        '#5087EC',
        '#68BBC4',
        '#58A55C',
        '#F2BD42',
        '#EE752F',
        '#88652F',
        '#861511',
        '#F61511',
        '#F6F511',
        '#616531',
        '#816371',
        '#819371'
      ]
    };
  },
  methods:{
    onQh() {
      this.page = 1;
      switch (this.but_qs) {
        case '最近1周':
          // 本周周一 -> 当前
          this.edi_time = [
            moment().startOf('isoWeek').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
        case '最近2周':
          // 前一周周一 -> 当前
          this.edi_time = [
            moment().startOf('isoWeek').subtract(7, 'days').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
        case '最近30天':
          // 当月1号 -> 当前
          this.edi_time = [
            moment().startOf('month').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
      }
      this.getOrderCountList();
    },
    handleDateChange() {
      this.page = 1;
      this.but_qs = '';
      this.getOrderCountList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrderCountList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOrderCountList();
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    drawMidLine1() {
      let myMidC1 = this.$echarts.getInstanceByDom(
          document.getElementById('myMidC1')
      );
      if (myMidC1 == null) {
        this.myMidC1 = this.$echarts.init(document.getElementById('myMidC1'));
      } else {
        this.myMidC1.clear();
      }
      let isEmpty = !this.li_mid1 || this.li_mid1.length === 0;
      this.myMidC1.setOption({
        title:isEmpty ? {
          text:'暂无数据',
          left:'center',
          top:'center',
          textStyle:{
            color:'#999',
            fontSize:16
          }
        }:{
          text:'',
          subtext:'',
          x:'left',
          padding:[
            0,
            0,
            0,
            0
          ],
          textStyle:{
            color:'#ccc',
            fontSize:16
          }
        },
        tooltip:isEmpty ? {show:false}:{
          trigger:'axis'
        },
        color:[
          '#4472C5',
          '#ED7C30'
        ],
        legend:isEmpty ? {show:false}:{
          orient:'horizontal',
          left:'center',
          bottom:'0%',
          padding:[
            0,
            0,
            0,
            5
          ],
          data:this.li_mid1Name,
          textStyle:{
            color:'#ccc',
            fontSize:16
          }
        },
        grid:isEmpty ? {show:false}:{
          left:'2%',
          right:'2%',
          top:'10%',
          bottom:'12%',
          containLabel:true
        },
        xAxis:isEmpty ? {show:false}:{
          type:'category',
          data:this.li_mid1X,
          name:'',
          show:true,
          axisLabel:{
            color:'#ccc',
            fontSize:14
          }
        },
        yAxis:isEmpty ? {show:false}:{
          type:'value',
          name:'',
          axisLabel:{
            color:'#ccc',
            fontSize:14
          }
        },
        series:isEmpty ? []:this.li_mid1
      });
    },
    drawMidLine2() {
      let myMidC2 = this.$echarts.getInstanceByDom(
          document.getElementById('myMidC2')
      );
      if (myMidC2 == null) {
        this.myMidC2 = this.$echarts.init(document.getElementById('myMidC2'));
      } else {
        this.myMidC2.clear();
      }
      let isEmpty = !this.li_mid2 || this.li_mid2.length === 0;
      this.myMidC2.setOption({
        title:isEmpty ? {
          text:'暂无数据',
          left:'center',
          top:'center',
          textStyle:{
            color:'#999',
            fontSize:16
          }
        }:{
          text:'',
          subtext:'',
          x:'left',
          padding:[
            0,
            0,
            0,
            0
          ],
          textStyle:{
            color:'#ccc',
            fontSize:16
          }
        },
        tooltip:isEmpty ? {show:false}:{
          trigger:'axis'
        },
        color:[
          '#4472C5',
          '#ED7C30'
        ],
        grid:isEmpty ? {show:false}:{
          left:'2%',
          right:'2%',
          top:'10%',
          bottom:'0%',
          containLabel:true
        },
        xAxis:isEmpty ? {show:false}:{
          type:'category',
          data:this.li_mid2X,
          name:'',
          show:true,
          axisLabel:{
            color:'#ccc',
            fontSize:14
          }
        },
        yAxis:isEmpty ? {show:false}:{
          type:'value',
          name:'',
          axisLabel:{
            color:'#ccc',
            fontSize:14
          }
        },
        series:isEmpty ? []:this.li_mid2
      });
    },
    drawMidLine3() {
      let myMidC3 = this.$echarts.getInstanceByDom(
          document.getElementById('myMidC3')
      );
      if (myMidC3 == null) {
        this.myMidC3 = this.$echarts.init(document.getElementById('myMidC3'));
      } else {
        this.myMidC3.clear();
      }
      let isEmpty = !this.li_mid3 || this.li_mid3.length === 0;
      this.myMidC3.setOption({
        title:isEmpty ? {
          text:'暂无数据',
          left:'center',
          top:'center',
          textStyle:{
            color:'#999',
            fontSize:16
          }
        }:{
          text:'',
          subtext:'',
          x:'left',
          padding:[
            0,
            0,
            0,
            0
          ],
          textStyle:{
            color:'#ccc',
            fontSize:16
          }
        },
        tooltip:isEmpty ? {show:false}:{
          trigger:'axis'
        },
        color:[
          '#4472C5',
          '#ED7C30'
        ],
        legend:isEmpty ? {show:false}:{
          orient:'horizontal',
          left:'center',
          bottom:'0%',
          padding:[
            0,
            0,
            0,
            5
          ],
          data:this.li_mid3Name,
          textStyle:{
            color:'#ccc',
            fontSize:16
          }
        },
        grid:isEmpty ? {show:false}:{
          left:'2%',
          right:'2%',
          top:'10%',
          bottom:'12%',
          containLabel:true
        },
        xAxis:isEmpty ? {show:false}:{
          type:'category',
          data:this.li_mid3X,
          name:'',
          show:true,
          axisLabel:{
            color:'#ccc',
            fontSize:14
          }
        },
        yAxis:isEmpty ? {show:false}:{
          type:'value',
          name:'',
          axisLabel:{
            color:'#ccc',
            fontSize:14
          }
        },
        series:isEmpty ? []:this.li_mid3
      });
    },
    drawMidLine4() {
      let myTopC1 = this.$echarts.getInstanceByDom(
          document.getElementById('myMidC4')
      );
      if (myTopC1 == null) {
        this.myTopC1 = this.$echarts.init(document.getElementById('myMidC4'));
      } else {
        this.myTopC1.clear();
      }
      let isEmpty = !this.li_mid4 || this.li_mid4.length === 0;
      this.myTopC1.setOption({
        title:isEmpty ? {
          text:'暂无数据',
          left:'center',
          top:'center',
          textStyle:{
            color:'#999',
            fontSize:16
          }
        }:undefined,
        series:isEmpty ? []:[
          {
            name:'',
            type:'pie',
            radius:[
              '60%',
              '80%'
            ],
            data:this.li_mid4,
            label:{
              formatter:function (params) {
                return params.name;
              },
              fontWeight:'normal',
              fontSize:13,
              color:'#000000',
              textStyle:{
                fontWeight:'bold'
              }
            }
          }
        ],
        graphic:isEmpty ? undefined:{
          elements:[
            {
              type:'text',
              left:'center',
              top:'center',
              style:{
                text:this.li_mid4.reduce((total,item) => total + item.value,0),
                textAlign:'center',
                fill:'#333',
                fontSize:25
              }
            }
          ]
        }
      });
    },
    initMid1(data) {
      console.log("liMid1",data);
      if (!data || data.length === 0) {
        this.liMid1 = [];
        this.li_mid1 = [];
        this.li_mid1X = [];
        this.li_mid1Name = [];
        this.drawMidLine1();
        return;
      }
      let ll = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          "day":data[i]['day'],
          "orderTotalMoney":data[i]['orderTotalMoney'] / 100,
          "orderRefundMoney":data[i]['orderRefundMoney'] / 100,
          "orderTotalNum":data[i]['orderTotalNum']
        };
        if (data[i]['day'] === '-1') {
          continue;
        }
        ll.push(d);
      }
      this.liMid1 = ll;
      let l_qt = [];
      let l_nlName = [];
      let liXName = [];
      let liLow = [
        {'count':0,'name':"订单总金额"},
        {'count':1,'name':"订单总数"},
        {'count':2,'name':"订单退款"}
      ];
      let li_type = [
        "bar",
        "bar",
        'line'
      ];
      for (let i = 0; i < liLow.length; i++) {
        const l1 = [];
        let isX = true;
        if (liXName.length > 0) {
          isX = false;
        }
        for (let j = 0; j < this.liMid1.length; j++) {
          if (isX) {
            liXName.push(this.liMid1[j]["day"]);
          }
          if (i === 0) {
            l1.push(this.liMid1[j]["orderTotalMoney"]);
          } else if (i === 1) {
            l1.push(this.liMid1[j]["orderTotalNum"]);
          } else if (i === 2) {
            l1.push(this.liMid1[j]["orderRefundMoney"]);
          }
        }
        let d = {
          name:liLow[i]["name"],
          data:l1,
          label:{
            show:true,
            position:'top', // 标签的位置，这里设置为 'top' 表示在柱状图的顶部显示
            formatter:'{c}', // c 代表数据值
            color:'#333',
            fontSize:12
          },
          type:li_type[i],
          itemStyle:{
            color:this.li_color[i]
          },
          tooltip:{
            valueFormatter:function (value) {
              return value;
            }
          }
        };
        l_qt.push(d);
        l_nlName.push(d["name"]);
      }
      this.li_mid1 = l_qt;
      this.li_mid1X = liXName;
      this.li_mid1Name = l_nlName;
      console.log("li_mid1",this.li_mid1);
      this.drawMidLine1();
    },
    initMid2(data) {
      console.log("liMid2",data);
      if (!data || data.length === 0) {
        this.liMid2 = [];
        this.li_mid2 = [];
        this.li_mid2X = [];
        this.li_mid2Name = [];
        this.drawMidLine2();
        return;
      }
      let ll = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          month:data[i]['roomName'],
          roomId:data[i]['roomId'],
          orderTotalNum:data[i]['orderTotalNum']
        };
        ll.push(d);
      }
      this.liMid2 = ll;
      let l_qt = [];
      let l_nlName = [];
      let liXName = [];
      let liLow = [
        {'count':30,'name':"订单总数"}
      ];
      let li_type = [
        "bar"
      ];
      for (let i = 0; i < liLow.length; i++) {
        const l1 = [];
        let isX = true;
        if (liXName.length > 0) {
          isX = false;
        }
        for (let j = 0; j < this.liMid2.length; j++) {
          if (isX) {
            liXName.push(this.liMid2[j]["month"]);
          }
          if (i === 0) {
            l1.push(this.liMid2[j]["orderTotalNum"]);
          }
        }
        let d = {
          name:liLow[i]["name"],
          data:l1,
          label:{
            show:true,
            position:'top', // 标签的位置，这里设置为 'top' 表示在柱状图的顶部显示
            formatter:'{c}', // c 代表数据值
            color:'#333',
            fontSize:12
          },
          type:li_type[i],
          itemStyle:{
            color:this.li_color[i]
          },
          tooltip:{
            valueFormatter:function (value) {
              return value;
            }
          }
        };
        l_qt.push(d);
        l_nlName.push(d["name"]);
      }
      this.li_mid2 = l_qt;
      this.li_mid2X = liXName;
      this.li_mid2Name = l_nlName;
      console.log("li_mid2",this.li_mid2);
      this.drawMidLine2();
    },
    initMid3(data) {
      console.log("liMid3",data);
      if (!data || data.length === 0) {
        this.liMid3 = [];
        this.li_mid3 = [];
        this.li_mid3X = [];
        this.li_mid3Name = [];
        this.drawMidLine3();
        return;
      }
      let ll = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          day:data[i]['day'],
          orderRefundRate:data[i]['orderRefundRate'],
          orderRefundMoney:data[i]['orderRefundMoney'] / 100,
          orderRefundNum:data[i]['orderRefundNum']
        };
        if (data[i]['day'] === '-1') {
          continue;
        }
        ll.push(d);
      }
      this.liMid3 = ll;
      let l_qt = [];
      let l_nlName = [];
      let liXName = [];
      let liLow = [
        {'count':0,'name':"退款率"},
        {'count':1,'name':"退款金额"},
        {'count':2,'name':"退款订单数"}
      ];
      let li_type = [
        "bar",
        "bar",
        'line'
      ];

      for (let i = 0; i < liLow.length; i++) {
        const l1 = [];
        let isX = true;
        if (liXName.length > 0) {
          isX = false;
        }
        for (let j = 0; j < this.liMid3.length; j++) {
          if (isX) {
            liXName.push(this.liMid3[j]["day"]);
          }
          if (i === 0) {
            l1.push(`${this.liMid3[j]["orderRefundRate"]}`);
          } else if (i === 1) {
            l1.push(this.liMid3[j]["orderRefundMoney"]);
          } else if (i === 2) {
            l1.push(this.liMid3[j]["orderRefundNum"]);
          }
        }

        let d = {
          name:liLow[i]["name"],
          data:l1,
          label:{
            show:true,
            position:'top',
            // 退款率标签添加 %
            formatter:i === 0 ? '{c}%':'{c}',
            color:'#333',
            fontSize:12
          },
          type:li_type[i],
          itemStyle:{
            color:this.li_color[i]
          },
          tooltip:{
            // 退款率 tooltip 添加 %
            valueFormatter:i === 0
                ? function (value) {
                  return `${value}%`;
                }
                :function (value) {
                  return `${value}`;
                }
          }
        };

        l_qt.push(d);
        l_nlName.push(d["name"]);
      }

      this.li_mid3 = l_qt;
      this.li_mid3X = liXName;
      this.li_mid3Name = l_nlName;
      console.log("li_mid3",this.li_mid3);
      this.drawMidLine3();
    },
    initMid4(data) {
      console.log("liMid4",data);
      if (!data || data.length === 0) {
        this.liMid4 = [];
        this.li_mid4 = [];
        this.drawMidLine4();
        return;
      }
      let l_qt = [];
      let li_color = [
        '#5087EC',
        '#68BBC4',
        '#58A55C',
        '#F2BD42',
        '#EE752F',
        '#88652F',
        '#861511'
      ];
      let ll = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          reason:data[i]['reason'],
          count:data[i]['num']
        };
        ll.push(d);
      }
      this.liMid4 = ll;
      for (let i = 0; i < this.liMid4.length; i++) {
        let d = {
          value:this.liMid4[i]["count"],
          name:this.liMid4[i]["reason"],
          color:li_color[i],
          itemStyle:{
            color:li_color[i]
          }
        };
        l_qt.push(d);
      }
      this.li_mid4 = l_qt;
      console.log("li_mid4",this.li_mid4);
      this.drawMidLine4();
    },
    init_view(data) {
      let ll = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          day:data[i]['day'],
          roomId:data[i]['roomId'],
          roomName:data[i]['roomName'],
          totalMoney:data[i]['totalMoney'] / 100,
          refundMoney:data[i]['refundMoney'] / 100,
          netIncome:data[i]['netIncome'] / 100,
          orderNum:data[i]['orderNum'],
          refundNum:data[i]['refundNum']
        };
        ll.push(d);
      }
      this.orderList = ll;
    },
    getOrderCountList() {
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        projectId:localStorage.getItem("projectId")
      };
      if (this.but_qs === "最近1周") {
        params['type'] = 1;
      } else if (this.but_qs === "最近2周") {
        params['type'] = 2;
      } else if (this.but_qs === "最近30天") {
        params['type'] = 3;
      } else if (this.edi_time) { /*订单时间*/
        params['fromTime'] = parseInt("" + new Date(this.edi_time[0] + 'T00:00:00').getTime() / 1000);
        params['toTime'] = parseInt(new Date(this.edi_time[1] + 'T00:00:00').getTime() / 1000) + 86400; /*结尾+1天*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getOrderStatistic2List,params,headers).then(res => {
        console.log("getOrderStatistic2List",res.data.data);
        this.total = res.data.data.total;
        if (res.data.data) {
          let li_d = res.data.data;
          this.orderTotalNum = li_d.orderTotalNum;
          this.orderTotalMoney = li_d.orderTotalMoney / 100;
          this.orderRefundNum = li_d.orderRefundNum;
          this.orderRefundMoney = li_d.orderRefundMoney / 100;
          this.orderRefundRate = li_d.orderRefundRate;
          if (li_d['dayOrderStatistic']) {
            this.initMid1(li_d['dayOrderStatistic']);
          } else {
            this.initMid1([]);
          }
          if (li_d['roomStatistic']) {
            this.initMid2(li_d['roomStatistic']);
          } else {
            this.initMid2([]);
          }
          if (li_d['dayRefund']) {
            this.initMid3(li_d['dayRefund']);
          } else {
            this.initMid3([]);
          }
          if (li_d['refundReason']) {
            this.initMid4(li_d['refundReason']);
          } else {
            this.initMid4([]);
          }
          if (li_d['orderStatisticDetail'] && li_d['orderStatisticDetail'].length > 0) {
            this.init_view(li_d['orderStatisticDetail']);
          } else {
            this.orderList = [];
          }
        } else {
          this.orderTotalNum = 0;
          this.orderTotalMoney = 0;
          this.orderRefundNum = 0;
          this.orderRefundMoney = 0;
          this.orderRefundRate = 0;
          this.orderList = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取订单统计数据失败");
        }
      });
    }
  },
  mounted() {
    this.getOrderCountList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData2() {
      return this.liSku.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style scoped>
.orderReview {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.son-item {
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.stats-overview {
  margin-bottom: 10px;
  display: flex;
  background: #f5f7fa
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/orderReview.vue